export default class SessionCreationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'SessionCreationError';
  }
}
